import script from "./AIChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChat.vue?vue&type=script&setup=true&lang=js"

import "./AIChat.vue?vue&type=style&index=0&id=a4dedeb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4dedeb6"]])

export default __exports__